import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';

import { PoListViewAction } from '@po-ui/ng-components';

@Component({
  selector: 'app-sales-filial',
  templateUrl: './sales-filial.component.html',
  styleUrls: ['./sales-filial.component.css']
})
export class SalesFilialComponent implements OnInit {
  @Output() errorEmitter = new EventEmitter();

  topTooltip: string = 'Ranking de vendas por filial';
  topTooltipExcel: string = 'Download .xlsx';

  itemTm!: any;
  itemTmSplit!: any;
  itemTmTooltip!: any;
  itemTmLastYear!: any;

  itemPmpv!: any;
  itemPmpvSplit!: any;
  itemPmpvTooltip!: any;
  itemPmpvLastYear!: any;

  itemPa!: any;
  itemPaSplit!: any;
  itemPaTooltip!: any;
  itemPaLastYear!: any;

  itemTotal!: any;
  itemTotalSplit!: any;
  itemTotalTooltip!: any;
  itemTotalLastYear!: any;

  tableRanking = new Array();
  loading: boolean = false;
  errorApi: boolean = false;
  message: string = '';

  breadcrumbBoards: any = [];

  readonly actions: Array<PoListViewAction> = [
    {
      label: 'Detalhar',
      action: this.goToDetail.bind(this),
      icon: 'po-icon po-icon-eye'
    },
  ];

  constructor(private router: Router, private api: ApiService) { }

  ngOnInit() {
    this.api.setHeader();
    
    let grupoSelect:any = localStorage.getItem('grupoSelect');
    if (grupoSelect !== '') {
      let breadcrumbLinks = [{ label: 'GESTÃO LOJA', link: '/home/sale' }, { label: grupoSelect?.toUpperCase(), link: '/sales-group' }, { label: 'FILIAIS', link: '/sales-filial' }];
      localStorage.setItem('breadcrumbStatus', JSON.stringify(breadcrumbLinks));
    } else if (grupoSelect === '') {
      let breadcrumbLinks = [{ label: 'GESTÃO LOJA', link: '/home/sale' }, { label: 'FILIAIS', link: '/sales-filial' }];
      localStorage.setItem('breadcrumbStatus', JSON.stringify(breadcrumbLinks));
    } else {
      let breadcrumbLinks = [{ label: 'GESTÃO LOJA', link: '/home/sale' }];
      localStorage.setItem('breadcrumbStatus', JSON.stringify(breadcrumbLinks));
    }

    let salesFilialParams:any = localStorage.getItem('salesFilialParams');
    let salesFilialParamsJson = JSON.parse(salesFilialParams);
    let objFilter = {
      dataMin: salesFilialParamsJson[0].dateMin,
      dataMax: salesFilialParamsJson[0].dateMax,
      branch: salesFilialParamsJson[0].branch,
      selers: salesFilialParamsJson[0].selers,
    }
    this.filterItem(objFilter); 
  }

  goToDetail(item: any) {
    localStorage.setItem('filialSelect', item.Filial);
    localStorage.setItem('filialSelectCodigo', item.Código);
    this.router.navigate(['/sales-sallers']);
  }

  backHome() {
    this.router.navigate(['/home/sale']);
  }

  abreviarValor(value: any) {
    if (value < 1000) {
      return 'R$ ' + value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    }
  
    if (value < 1000000) {
      return 'R$ ' + (value / 1000).toFixed(2) + 'k';
    }
  
    return 'R$ ' + (value / 1000000).toFixed(2) + 'kk';
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    let dataRetorno = [];
    this.tableRanking = [];
    this.itemPa = '';
    this.itemPmpv = '';
    this.itemTm = '';
    this.itemTotal = '';
    if (item.branch != undefined) {
      this.rankingMethod(item).subscribe(data => {
        try {
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            dataRetorno = data.dataRow;
            
            this.itemPa = data.total['pa'];
            this.itemPa = parseFloat(this.itemPa);
            this.itemPa = this.itemPa.toLocaleString('pt-br', {maximumFractionDigits: 2});
            
            this.itemPmpv = data.total['pmpv'];
            this.itemPmpv = parseFloat(this.itemPmpv);
            this.itemPmpv = this.itemPmpv.toLocaleString('pt-br', {maximumFractionDigits: 2});

            this.itemTm = data.total['tm'];
            this.itemTm = parseFloat(this.itemTm);
            this.itemTm = this.itemTm.toLocaleString('pt-br', {maximumFractionDigits: 2});
            
            this.itemTotal = data.total['invoice_value'];
            this.itemTotal = parseFloat(this.itemTotal);
            this.itemTotal = this.itemTotal.toLocaleString('pt-br', {maximumFractionDigits: 2});

            this.exibitionItem();
            this.calcPorcent(data.dataRow[0], data.dataRowLastYear[0]);

            dataRetorno.map((el: any) => {
              this.tableRanking.push({
                'Código': el.branch_code,
                'Filial': el.branch_name,
                'Ticket Médio': this.abreviarValor(parseFloat(el.tm)),
                'PA': el.pa.toLocaleString('pt-br', {maximumFractionDigits: 2}),
                'PMPV': this.abreviarValor(parseFloat(el.pmpv)),
                'Total': this.abreviarValor(parseFloat(el.invoice_value)),
              })
              excelInfo.push({
                'Código': el.branch_code,
                'Filial': el.branch_name,
                'Ticket Médio': this.abreviarValor(parseFloat(el.tm)),
                'PA': el.pa.toLocaleString('pt-br', {maximumFractionDigits: 2}),
                'PMPV': this.abreviarValor(parseFloat(el.pmpv)),
                'Total': this.abreviarValor(parseFloat(el.invoice_value)),
              })
            });
            this.loading = false;
            excelInfo.unshift({});
            localStorage.setItem('ranking-filial', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_FILIAL;
            this.formatErrorMensagem(this.message);
            this.errorApi = true;
          }
          this.loading = false;
        } catch (error: unknown) {
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_FILIAL;
        this.formatErrorMensagem(error.message);
      })
    }
  }

  exibitionItem() {
    let splitItemTotal = this.itemTotal.split('.');
    
    if (splitItemTotal.length == 3) {
      this.itemTotalSplit = splitItemTotal[0] + 'M'
    } else if (splitItemTotal.length == 2) {
      this.itemTotalSplit = splitItemTotal[0] + 'K'
    } else {
      this.itemTotalSplit = this.itemTotal;
    }

    let splitItemTm = this.itemTm.split('.');
    if (splitItemTm.length == 3) {
      this.itemTmSplit = splitItemTm[0] + 'M'
    } else if (splitItemTm.length == 2) {
      this.itemTmSplit = splitItemTm[0] + 'K'
    } else {
      this.itemTmSplit = this.itemTm;
    }

    let splitItemPmpv = this.itemPmpv.split('.');
    if (splitItemPmpv.length == 3) {
      this.itemPmpvSplit = splitItemPmpv[0] + 'M'
    } else if (splitItemPmpv.length == 2) {
      this.itemPmpvSplit = splitItemPmpv[0] + 'K'
    } else {
      this.itemPmpvSplit = this.itemPmpv;
    }
  }

  calcPorcent(year: any, lastYear: any) {
    if (year && lastYear) {
      let subPmpv = (year.pmpv - lastYear.pmpv);
      let dividedPmpv = subPmpv / lastYear.pmpv;
      let resultPmpv = dividedPmpv * 100;
      lastYear.pmpv !== 0
        ? this.itemPmpvLastYear = resultPmpv.toFixed(2)
        : this.itemPmpvLastYear = 0;

      let subTm = (year.tm - lastYear.tm);
      let dividedTm = subTm / lastYear.tm;
      let resultTm = dividedTm * 100;
      lastYear.tm !== 0
        ? this.itemTmLastYear = resultTm.toFixed(2)
        : this.itemTmLastYear = 0;

      let subPa = (year.pa - lastYear.pa);
      let dividedPa = subPa / lastYear.pa;
      let resultPa = dividedPa * 100;
      lastYear.pa !== 0
        ? this.itemPaLastYear = resultPa.toFixed(2)
        : this.itemPaLastYear = 0;
      
      let subTotal = (year.invoice_value - lastYear.invoice_value);
      let dividedTotal = subTotal / lastYear.invoice_value;
      let resultTotal = dividedTotal * 100;
      lastYear.invoice_value !== 0
      ? this.itemTotalLastYear = resultTotal.toFixed(2)
      : this.itemTotalLastYear = 0;
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataRankingFilial = [];
    let objectRankingFilial = localStorage.getItem('ranking-filial');

    objectRankingFilial != null
      ? (dataRankingFilial = JSON.parse(objectRankingFilial))
      : (dataRankingFilial = []);
    const worksheetRankingFilial= XLSX.utils.json_to_sheet(dataRankingFilial);

    const workbook = {
      Sheets: {
        'ranking-filial': worksheetRankingFilial,
      },
      SheetNames: [
        'ranking-filial',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-ranking-filial' + EXCEL_EXTENSION);
  }

  rankingMethod(item: any) {
    return this.api.postTotalBranch(item.dataMin, item.dataMax, item.branch, item.selers);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: ranking-filial \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}

